/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{fromValues as e}from"../../../core/libs/gl-matrix-2/factories/vec3f64.js";import{fromValues as t}from"../../../core/libs/gl-matrix-2/factories/vec4f64.js";class s{constructor(s,r,o,i,a,c){this.texture=s,this.type=r,s.retain(),this.offsetAndScale=t(o.offset[0],o.offset[1],o.scale,o.scale),this.opacities=e(i,a,c)}destroy(){this.texture.release()}}export{s as TextureReference};
